module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_03@3x-af3650d84c924069fdb49d59b40ddc22.webp";